import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { FaHtml5, FaReact, FaCss3, FaNode, FaJava,FaGithub, FaAws } from 'react-icons/fa';
import { SiMongodb,SiSpringboot  } from 'react-icons/si';
import { DiMysql, DiJavascript1 } from 'react-icons/di';
import { BiLogoPostgresql } from 'react-icons/bi';
import { motion } from 'framer-motion';
import '../About/About.css';

const iconVariants = (duration) => ({
  initial: { y: -10 },
  animate: {
    y: [10, -10],
    transition: {
      duration: duration,
      ease: 'linear',
      repeat: Infinity,
      repeatType: 'reverse',
    },
  },
});

const technologies = [
  { icon: <FaJava color="#e53935" fontSize="4rem" />, name: 'Java' },
  { icon: <DiJavascript1 color="#ffd600" fontSize="4rem" />, name: 'JavaScript' },
  { icon: <FaHtml5 color="#f4b400" fontSize="4rem" />, name: 'HTML5' },
  { icon: <FaCss3 color="#1565c0" fontSize="4rem" />, name: 'CSS3' },
  { icon: <FaReact color="#00acc1" fontSize="4rem" />, name: 'React' },
  { icon: <FaNode color="#43a047" fontSize="4rem" />, name: 'Node.js' },
  { icon: <SiSpringboot color='#4caf50' fontSize="4rem" />,name:'SpringBoot'},
  { icon: <DiMysql color="#1565c0" fontSize="4rem" />, name: 'MySQL' },
  { icon: <BiLogoPostgresql color="#1565c0" fontSize="4rem" />, name: 'PostgreSQL' },
  { icon: <SiMongodb color="#4caf50" fontSize="4rem" />, name: 'MongoDB' },
  { icon: <FaGithub color="#fff" fontSize="4rem" />, name: 'Git' },
  { icon: <FaAws color="#ffd600" fontSize="4rem" />, name: 'AWS' },
];

const Skills = () => {
  return (
    <Box id='skills' py={12}>
      <motion.div
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.5 }}
      >
        <Typography variant="h3" align="center" sx={{color:'white',pb:4,pt:5}} gutterBottom>
          Technologies
        </Typography>
      </motion.div>
      <motion.div
        whileInView={{ opacity: 1, x: 0 }}
        initial={{ opacity: 0, x: -100 }}
        transition={{ duration: 1.5 }}
      >
        <Grid container spacing={4} justifyContent="center">
          {technologies.map((tech, index) => (
            <Grid item key={index}>
              <motion.div
                variants={iconVariants(2 + index * 0.1)}
                initial="initial"
                animate="animate"
              >
                <Card
                  variant="outlined"
                  sx={{
                    p: 4,
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    color:'white',
                    backgroundColor:'black',
                    boxShadow: '7px 5px 10px 1px white'
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" align="center" className='no-select' gutterBottom>
                      {tech.name}
                    </Typography>
                    {tech.icon}
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Box>
  );
};

export default Skills;